import React from 'react';
import { Link, useWindowSize } from 'vindi-ds-components';
import Header from '@templates/header';

function HeaderBills() {
  const { isMobile } = useWindowSize();

  return (
    <>
      {isMobile ? (
        <Header.Mobile
          links='/admin/reports'
          title='Faturas'
        />
      ) : (
        <Header.WithoutAction
          links={[
            <Link href='/admin/dashboard'>Início</Link>,
            <Link href='/admin/reports'>Relatórios</Link>,
          ]}
          title='Faturas'
        />
      )}
    </>
  );
}

export default HeaderBills;
